import React, { useState } from 'react';
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
const AdminNavbar = () => {
    const [open, setOpen] = useState(false);

    const toggleDropdown = () => {
        setOpen(!open);
    };
    return (
        <div className="navcontainer">
            <nav className="nav">
                <div className="nav-upper-options">
                    <div className="nav-option option1">
                        {/* <img
                            src="https://media.geeksforgeeks.org/wp-content/uploads/20221210182148/Untitled-design-(29).png"
                            className="nav-img"
                            alt="dashboard"
                        /> */}
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/dashboard">Dashboard </NavLink>
                        </li>
                        {/* <h3></h3> */}
                    </div>
                    <div className="option2 nav-option">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/AnnoucementList">Annoucement </NavLink>
                        </li>
                    </div>

                    <div className="option2 nav-option">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/AchievementList">Achievement </NavLink>
                        </li>
                    </div>

                    <div className="option2 nav-option">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/WallofFameList">WallofFame </NavLink>
                        </li>
                    </div>

                    <div className="option2 nav-option">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/MostPrefferedList">MostPreffered Test Series </NavLink>
                        </li>
                    </div>

                    <div className="option2 nav-option">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/SolvedPaperList">Solved Previous Year Question Papers </NavLink>
                        </li>
                    </div>

                    <div className="option2 nav-option">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/StudentExperienceList">What Our Students Say </NavLink>
                        </li>
                    </div>

                    <div className="option2 nav-option" style={{ position: 'relative' }}>
            <li className="nav-item">
                <span
                    className="nav-link"
                    onClick={toggleDropdown}
                    style={{ cursor: 'pointer', display: 'block', userSelect: 'none' }}
                >
                    Exam Preparation Data ▾
                </span>

                {open && (
                    <ul
                        style={{
                            listStyle: 'none',
                            padding: 0,
                            margin: 0,
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            background: '#fff',
                            border: '1px solid #ccc',
                            width: '220px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            zIndex: 1000
                        }}
                    >
                        <li className="nav-item">
                            <NavLink
                                className="nav-link"
                                to="/admin/ExamPreparationList"
                                style={linkStyle}
                            >
                                Exam Preparation
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link"
                                to="/admin/ExamPaperdetailInfoList"
                                style={linkStyle}
                            >
                                Exam Paper Detail Info
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link"
                                to="/admin/ExamdetailOverViewList"
                                style={linkStyle}
                            >
                                Exam Detail Overview
                            </NavLink>
                        </li>
                       
                        <li className="nav-item">
                            <NavLink
                                className="nav-link"
                                to="/admin/ExamDetailTestSeriesList"
                                style={linkStyle}
                            >
                                Exam Paper Detail Test Series
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link"
                                to="/admin/ExamDetailDescriptionList"
                                style={linkStyle}
                            >
                                Exam Paper Detail Description
                            </NavLink>
                        </li>
                    </ul>
                )}
            </li>
        </div>

                    

                    <div className="option2 nav-option">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/ExamPaperPreparationist">Exam Paper Prepration </NavLink>
                        </li>
                    </div>

                    <div className="option2 nav-option">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/ClassModalList">Class Modal </NavLink>
                        </li>
                    </div>


                    <div className="option2 nav-option">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/SubscriptionList">Subscription </NavLink>
                        </li>
                    </div>

                    <div className="option2 nav-option">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/TopExploreList">Explore Top Study Places </NavLink>
                        </li>
                    </div>


                    <div className="option2 nav-option">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/listRole">Role </NavLink>
                        </li>
                    </div>
                    <div className="option2 nav-option">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/competitiveListRole">Competitive </NavLink>
                        </li>
                    </div>
                    <div className="option2 nav-option">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/enquiries">Enquiries </NavLink>
                        </li>
                    </div>
                    <div className="option2 nav-option">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/latestNewsList">Latest News & Stories </NavLink>
                        </li>
                    </div>
                    <div className="option2 nav-option">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/instituteLoboList">Institute Lobo </NavLink>
                        </li>
                    </div>
                    <div className="option2 nav-option">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/admin/listInstitute">Institutes </NavLink>
                        </li>
                    </div>

                    <div className="nav-option logout">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/">Logout </NavLink>
                        </li>
                    </div>
                </div>
            </nav>
        </div>
    );
};


const linkStyle = {
    display: 'block',
    padding: '10px 20px',
    textDecoration: 'none',
    color: '#333',
    background: '#fff'
};

export default AdminNavbar;